import React from "react";

export default function Regions({ data }) {
  if (!data) return null;
  return (
    <section className="regions" aria-label="Client regions">
      <div className="wrap regions-inner">
        <span className="regions-label">{data.label}</span>
        <ul className="regions-list">
          {data.items.map((country, i) => (
            <li key={i}>{country}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}
